module.exports = __webpack_public_path__ + "static/media/mountain-bg.121a16c1.png";